import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { IconSettings } from 'library/styles/icon';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px 40px 20px;
  background-color: ${Colors.shade07};
  background: ${Colors.shade08};
  box-shadow: 0 2px 10px rgba(45, 49, 50, 0.08);
  border-radius: 4px;
  margin-top: 10px;
  margin-bottom: 145px;
`;

const TopTextContainer = styled.div`
  margin: 17px 0 0 0;
`;

const TextContainer = styled.div`
  margin: 25px 0;
`;

const InfoText = styled.p`
  font-size: 18px;
  line-height: 28px;
  color: ${Colors.shade02};
  margin: 4px 0;
`;

const Info = styled.a`
  font-size: 18px;
  line-height: 28px;
  margin: 4px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  text-decoration: none;
  padding: 25px 0;
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'inherit')};
  // color: ${({ isDisabled }) => (isDisabled ? '#7F8C90' : Colors.link)};
  
  p, i, a {
    color: ${({ isDisabled }) => (isDisabled ? '#7F8C90' : Colors.link)};
  }
`;

const IconContainer = styled.div`
  width: 32px;
  height: 32px;
`;

const Icon = styled(IconSettings)``;

const IconText = styled.p`
  font-size: 18px;
  line-height: 28px;
  color: ${Colors.violet};
  margin: 0 10px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background: ${Colors.shade06};
`;

export {
  Container,
  InfoText,
  Info,
  IconContainer,
  Icon,
  IconText,
  Line,
  TextContainer,
  TopTextContainer,
};
